// extracted by mini-css-extract-plugin
module.exports = {"text":"text--3tplk","counter":"counter--2h2Aj","hidden":"hidden--26C2e"};